import search from "../../assets/images/Search.svg";
import { Link, useNavigate } from "react-router-dom";
import { TrainingRuotes } from "../../routes";
import "./Sidebar.scss";
import { useSelector } from "react-redux";
import { getUser } from "../../store/slices/auth-slice";
import { ROLES, USER_TYPES } from "../../constants";
import dashboard from "../../assets/images/Dashboard.svg";
function TrainingLinks() {
  const currentUser = useSelector(getUser)
  const navigate = useNavigate()
  const studentPages = ['ratings', 'achievements']
  const instructorPages = ['students']
  return (
    <>
     <li style={{ display: "flex", gap: "10px" }}>
            <img src={dashboard} alt="Dashboard Logo" />
            <Link to="/">Dashboard</Link>
          </li>
      {TrainingRuotes?.filter((r) => !r.children).map((route, i) => {
        if (route.path.includes(USER_TYPES.STUDENTS) && currentUser?.role === ROLES.STUDENT) {
          return null
        }
        if (route.path.includes(USER_TYPES.INSTRUCTORS) && currentUser?.role === ROLES.INSTRUCTOR) {
          return null
        }
        if (currentUser?.role === ROLES.INSTRUCTOR && studentPages.some(path => route.path.includes(path))) {
          return null
        }
        return <li key={i} style={{ display: "flex", gap: "10px" }} onClick={() => navigate(route.path)}>
          <img src={search} alt="Search Logo" />
          <Link to={route.path}>{route.lable}</Link>
        </li>
      })}
    </>
  );
}
export default TrainingLinks;
